<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col cols="12">
            <v-card
              class="pa-6"
              :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
            >
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0">
                  <history-table
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import HistoryTable from '@/components/history/HistoryTable.vue'

export default {
  components: {
    HistoryTable
  },

  data() {
    return {
      loading: true,
      familyList: []
    }
  },

  computed: {
    title() {
      return 'ญาติสายตรง'
    },

    headers() {
      return [
        {
          text: 'ชื่อ-สกุล',
          value: 'familyName'
        },
        {
          text: 'ความสัมพันธ์',
          value: 'familyRelationshipName'
        },
        { text: 'บุตรคนที่', value: 'childNumber' },
        { text: 'อายุ', value: 'age' },
        {
          text: 'ประเภทอาชีพ',
          value: 'occupationTypeName'
        },
        {
          text: 'ใช้สิทธิเบิกสวัสดิการของตนเอง',
          value: 'welfareClaimName'
        },
        { text: 'สถานะ', value: 'lifeStatusName' },
        {
          text: 'ใช้สิทธิ์สวัสดิการของพนักงานมหาวิทยาลัย',
          value: 'welfare'
        }
      ]
    },

    items() {
      const lang = this.$root.$i18n.locale
      return this.familyList.map(item => {
        item.familyRelationshipName = item[`familyRelationshipName${lang}`]
        return item
      })
    }
  },

  async mounted() {
    this.familyList = (await this.apiGetHistoryFamilies()) || []
    this.loading = false
  },

  methods: {
    async apiGetHistoryFamilies() {
      try {
        const res = await this.$store.dispatch(
          'history/getFamilies',
          this.$guid
        )
        return res.data?.data?.familyList || []
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
